import React from 'react';

const SocialIconModal = ({ isOpen, onClose, socialName, href, message }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: -60,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000, // Very high z-index
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(1px)',
        background: 'rgba(0, 0, 0, 0.1)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '8px',
          width: '320px',
          padding: '0',
          textAlign: 'center',
          position: 'relative',
          animation: 'fadeIn 0.2s ease-out',
          overflow: 'hidden',
          backdropFilter: 'blur(2px)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            background:
              'linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)',
            color: 'white',
            padding: '12px 20px',
            fontSize: '18px',
            fontWeight: '500',
            letterSpacing: '0.5px',
          }}
        >
          Open {socialName}
        </div>

        {/* Content */}
        <div style={{ padding: '10px 10px' }}>
          <p
            style={{
              marginTop: '10px',
              fontSize: '16px',
              fontWeight: '400',
              color: '#333',
            }}
          >
            {message ||
              `Are you sure you want to leave Tringbox to visit ${socialName}?`}
          </p>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '0', justifyContent: 'stretch' }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '8px 16px',
              fontWeight: '500',
              border: 'none',
              background:
                'linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)',
              color: 'white',
              cursor: 'pointer',
              fontSize: '16px',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            <span style={{ fontSize: '18px', fontWeight: '300' }}>✕</span>
            No
          </button>
          <a
            href={href}
            rel="noopener noreferrer"
            target="_blank"
            onClick={onClose}
            style={{
              flex: 1,
              padding: '8px 16px',
              fontWeight: '500',
              border: '1px solid #CC151E',
              background: 'white',
              color: '#CC151E',
              cursor: 'pointer',
              fontSize: '16px',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            <span style={{ fontSize: '16px', fontWeight: '300' }}>✓</span>
            Yes
          </a>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { 
            opacity: 0;
            transform: scale(0.95);
          }
          to { 
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default SocialIconModal;
